export default function AOSerpFAQs() {
  this.initiate = () => {
    document.querySelectorAll('.js-ao-serp-faqs-collapse').forEach((faqCollapse) => {
      faqCollapse.addEventListener('click', (e) => {
        const $clickedCollapse = $(e.currentTarget);
        $clickedCollapse.toggleClass('ao-rotate-icon');
        const $parent = $clickedCollapse.parent().parent();
        const answerElement = $parent.find('.ao-serp-faqs-section__list-item__answer');
        const dateElement = $parent.find('.ao-serp-faqs-section__list-item__date');
        $(answerElement).toggleClass('hid');
        $(dateElement).toggleClass('hid');
      });
    });
  };
}
